// extracted by mini-css-extract-plugin
export default {"button":"style_button__9U902","dark":"style_dark__D6rBT"};